<div class="specific-container">
    <div class="bckp-servers-name" title="{{ item.result.server }}">
        {{ item.result.serverShort }}
    </div>
    <div class="bckp-servers-master" title="{{ item.result.master }}">
        {{ item.result.master }}
    </div>
    <div
        class="bckp-servers-policy-name"
        title="{{ item.result.policyName }}"
    >
        {{ item.result.policyName }}
    </div>
    <div
        class="bckp-servers-policy-type"
        title="{{ item.result.policyType }}"
    >
        {{ item.result.policyType }}
    </div>
    <div
        class="bckp-servers-schedule-name"
        title="{{ item.result.scheduleName }}"
    >
        {{ item.result.scheduleName }}
    </div>
    <div
        class="bckp-servers-schedule-type"
        title="{{ item.result.scheduleType }}"
    >
        {{ item.result.scheduleType }}
    </div>
    <div class="bckp-servers-age" title="{{ item.result.backupTime }}">
        {{ item.result.ageBackup }}
    </div>
    <div
        class="bckp-servers-expire"
        title="{{ item.result.expirationTime }}"
    >
        {{ item.result.futureExpiration }}
    </div>
</div>
